import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteTrackCount({
  to,
  from,
}: {
  from: string
  to: string
}): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/graph/track-count/?from=${from}&to=${to}`)
}
